import { Tag } from "@chakra-ui/react";

interface TagStatusCardProps {
  icon?: React.ReactNode;
  title: string;
  colorScheme: string;
}

export default function TagStatusCard({
  colorScheme,
  title,
  icon,
}: TagStatusCardProps) {
  return (
    <Tag
      rounded={5}
      px={1}
      py={1}
      gap={1}
      colorScheme={colorScheme}
      size="xs"
      fontSize={11}
    >
      {icon}
      {title}
    </Tag>
  );
}
